import { Component, ViewChild } from '@angular/core';

import {
    AlertController, App, FabContainer, ItemSliding, List, ModalController, NavController, ToastController,
    LoadingController, Refresher, Tabs, ActionSheetController
} from 'ionic-angular';

/*
  To learn how to use third party libs in an
  Ionic app check out our docs here: http://ionicframework.com/docs/v2/resources/third-party-libs/
*/
// import moment from 'moment';

import { ConferenceData } from '../../../../providers/conference-data';
import { UserData } from '../../../../providers/user-data';
import {MissionsData} from "../../../../providers/missions-data";

import { SessionDetailPage } from '../../../session-detail/session-detail';
import { ScheduleFilterPage } from '../../../schedule-filter/schedule-filter';
import {MissionsMapPage} from "../../missions-map/missions-map";
import {MissionDetailPage} from "../../mission-detail/mission-detail";
import { MissionsCandidateDetailPage } from '../../missions-candidate/missions-candidate-detail/missions-candidate-detail';
import {MissionsFilterPage} from "../../missions-filter/missions-filter";


import {AngularFireDatabase} from "angularfire2/database";



import {LocationSelectForm} from "../../../utils/location-select/location-select";
import {Geolocation} from "@ionic-native/geolocation";
import {MissionsContractListPage} from "../../missions-contract/missions-contract-list/missions-contract-list";
import {UiData} from "../../../../providers/ui-data";
import {CivilityPage} from "../../../account/civility/civility";
import {AddressPage} from "../../../account/address/address";
import {MissionsCandidatePage} from "../mission-candidate-list/missions-candidate";
import {Signpad} from "../../../utils/signpad/signpad";
import {Timesheet} from "../../../utils/timesheet/timesheet";

declare var google: any;

@Component({
    selector: 'page-missions-calendar',
    templateUrl: 'missions-calendar.html'
})
export class MissionsCalendarPage {
    // the list is a child of the schedule page
    // @ViewChild('scheduleList') gets a reference to the list
    // with the variable #scheduleList, `read: List` tells it to return
    // the List and not a reference to the element
    @ViewChild('scheduleList', { read: List }) scheduleList: List;

    userInfos: any;
    dayIndex = 0;
    queryText = '';
    segment: any = 'candidates';
    locationSelectModal: any;
    locationSelectModalInited: boolean = false;
    excludeTracks: any = [];
    shownSessions: any = [];
    groups: any = [];
    confDate: string;

    missions:any;
    contracts:any;
    locationAsked:boolean=false;

    empty: any = false;
    contracts_empty: any = false;
    inited: any = false;
    loading: any = false;
    currently_loading: any = false;
    calendar: any;

    constructor(
        public alertCtrl: AlertController,
        public app: App,
        public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,
        public navCtrl: NavController,
        public toastCtrl: ToastController,
        public userData: UserData,
        public uiData: UiData,
        public missionsData: MissionsData,
        public afDatabase: AngularFireDatabase,
        private geolocation: Geolocation,
        public actionSheetCtrl: ActionSheetController
    ) {
        //this.setLoading(true,"Chargement du planning");
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }
    calendarLoaded(data)
    {

        this.calendar = data.calendar;

    }
    calendarMonthChange(data)
    {
        if(this.calendar)
        {
            //console.log('CALENDAR Month Change',data);
        }
    }
    dayClick(data)
    {
        var that = this;
        if(this.calendar)
        {
            if(data.isMissionDay && data.missionDayInformation) {

                /*
                ACTION SHEETE : Multiple actions

                var buttons = [];
                buttons.push({
                        text: 'Détail de la mission',
                        role: 'destructive',
                        handler: () => {
                            console.log('Destructive clicked');
                            that.navCtrl.push(MissionsCandidateDetailPage, { missionId: data.missionDayInformation.missionOffer});
                        }
                    });
                if(data.missionDayInformation.state=='opened') {
                    buttons.push({
                        text: 'Réaliser mon check-in pour le '+data.date+'/'+(data.month+1)+'/'+data.year,
                        role: 'destructive',
                        handler: () => {
                            console.log('Destructive clicked');
                            that.showCheckbox(data,true);
                        }
                    });
                }
                if(data.missionDayInformation.state=='missing') {
                    buttons.push({
                        text: 'Déclarer mes horaires du '+data.date+'/'+(data.month+1)+'/'+data.year,
                        role: 'destructive',
                        handler: () => {
                            console.log('Destructive clicked');
                            that.showTimesheet(data,true);
                        }
                    });
                }
                if(data.missionDayInformation.state=='checked-in') {
                    buttons.push({
                        text: 'Réaliser mon check-out pour le '+data.date+'/'+(data.month+1)+'/'+data.year,
                        role: 'destructive',
                        handler: () => {
                            console.log('Destructive clicked');
                            that.showCheckbox(data,false);
                        }
                    });
                }
                buttons.push({
                    text: 'Annuler',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                });
                let actionSheet = this.actionSheetCtrl.create({
                    title: 'Opérations',
                    buttons: buttons
                });

                actionSheet.present();
                */
                if(data.missionDayInformation.state=='missing') {
                    this.showTimesheet(data,true);
                }
                else if (data.missionDayInformation.state=='opened') {

                    this.showTimesheet(data,false);
                }
                else
                {
                    this.navCtrl.push(MissionsCandidateDetailPage, { missionId: data.missionDayInformation.missionOffer});
                }
            }
        }
    }
    showTimesheet(data,chkin) {
        var that = this;
        var missionDayInformation = data.missionDayInformation;
        let documentSelectModal = this.modalCtrl.create(Timesheet,{missionData:missionDayInformation,checkin:data});
        documentSelectModal.onDidDismiss(data => {
            if(data)
            {
                this.missionsData.setHours(missionDayInformation,data);
            }
            else
            {

            }
        });
        documentSelectModal.present();
    }
    showCheckbox(data,chkin) {

        var that = this;
        let alert = this.alertCtrl.create();
        if(chkin)
        {
            //alert.setTitle('Check-in du '+data.date+'/'+(data.month+1)+'/'+data.year);
            alert.setSubTitle('Il est '+'8h00'+'. Vous débutez votre journée ?');
            alert.setMessage('Ces horaires approximatifs seront intégrés à vos relevés d\'heures du '+data.date+'/'+(data.month+1)+'/'+data.year);
        }
        else
        {
            //alert.setTitle('Check-out '+data.date+'/'+(data.month+1)+'/'+data.year);
            alert.setSubTitle('Il est '+'8h00'+'. Vous terminez votre journée ?');
            alert.setMessage('Ces horaires approximatifs seront intégrés à vos relevés d\'heures du '+data.date+'/'+(data.month+1)+'/'+data.year);
        }
        alert.addButton('Annuler');
        alert.addButton({
            text: 'Oui !',
            handler: none => {
                that.missionsData.setCheckin(data.missionDayInformation,chkin);
            }
        });
        alert.present();
    }
    ionViewDidLoad() {
        this.userData.tutorialPopin('UserCalendar');
    }
    ionViewWillEnter(){
        this.getUserInfos();
    }
    getUserInfos() {

        var that=this;
        if(!this.inited) {
            this.inited=true;
            this.setLoading(true,'Chargement de vos informations ...');
        }
        this.missions = {};
        that.userData.userSession().subscribe(session => {
            if(session!==null)
            {
                that.userData.load().subscribe(user => {
                    //that.userData.checkLoggedIn(this.navCtrl,'MissionsListPage');
                    that.setLoading(false);
                    that.missions = that.missionsData.getUserMissionsCandidates();
                    that.empty = (that.missions.visible.length ==0 );

                    that.contracts = that.missionsData.getUserMissionsContracts();
                    that.contracts_empty = (that.contracts.visible.length ==0 );

                    if(that.calendar) {
                        that.calendar.pushWholePlanning(that.userData.get('missionPeriods'));
                    }

                });
            }
        });


    }
    getContractsStatusLabels(str="")
    {
        var statusLabels = {
            'in-progress': "En cours",
            'scheduled': "Programmées",
            'closed': "Terminées",
            'canceled': "Annulées"
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    getContractsStatusSubline(str="")
    {
        var statusLabels = {
            'in-progress': "Missions en cours de réalisation",
            'scheduled': "Missions acceptées / à venir",
            'closed': "Missions terminées",
            'canceled': "Missions annulées par l'employeur"
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    getContractsStatusIcons(str="")
    {
        var statusLabels = {
            'in-progress': "timer",
            'scheduled': "stopwatch",
            'closed': "checkmark-circle",
            'canceled': "cross"
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    getStatusLabels(str="")
    {
        var statusLabels = {
            'submitted':'En attente',
            'refused':'Refusées',
            'canceled': 'Annulées',
            'accepted': 'Acceptées'
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    getStatusSubline(str="")
    {
        var statusLabels = {
            'submitted':'Candidatures en attente d\'approbation',
            'refused':'Candidatures déclinées par l\'employeur',
            'canceled': 'Annulées par vos soins',
            'accepted': 'Candidature acceptées par l\'employeur'
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    getStatusIcons(str="")
    {
        var statusLabels = {
            'submitted':'pulse',
            'refused':'close',
            'canceled': 'trash',
            'accepted': "checkmark-circle",
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    cancelMission(mission)
    {

    }
    goToMissionDetail(missionData: any) {
        // go to the session detail page
        // and pass in the session data
        this.navCtrl.push(MissionsCandidateDetailPage, { missionId: missionData.id, name: missionData.name });
    }
    gotoContracts() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsContractListPage);
    }
    gotoCandidates() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsCandidatePage);
    }
    swipe(event)
    {
        if(event.direction === 2) {
            this.navCtrl.parent.select(3);
        }
        if(event.direction === 4) {
            this.navCtrl.parent.select(1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-candidate/missions-calendar/missions-calendar.ts